import Behaviour from '@/core';
import Flickity from 'flickity';
// import resizer from 'spon-resize'

export default class NewsFeed extends Behaviour {
	constructor(el) {
		super(el);

		// const viewport = resizer()

		this.flkty = new Flickity(el, {
			groupCells: 2,
			cellAlign: 'left',
			cellSelector: '[data-carousel-item]',
			pageDots: false,
			resize: false,
			arrowShape:
				'M99.7,48.6L71.9,19.3c-0.6-0.6-1.9-0.6-2.5,0c-0.6,0.6-0.6,1.9,0,2.5L94,48.3H1.9C0.6,48,0,49,0,49.9 c0,0.9,0.6,1.9,1.9,1.9h92.5L69.7,78.3c-0.6,0.6-0.6,1.9,0,2.5c0.6,0.6,1.9,0.6,2.5,0l27.5-29.4C100.3,50.2,100,49.3,99.7,48.6z',
		});

		// viewport.start()
		// viewport.at('(min-width: 42em)', {
		// 	match: () => {
		// 		// this.flkty.groupCells = 2
		// 		// log(this.flkty)
		// 	},

		// 	unmatch: () => {
		// 		// this.flkty.groupCells = 1
		// 		// log(this.flkty)
		// 	}
		// })
	}
}


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
